import React, { ComponentPropsWithRef } from "react";
import * as styles from "./Heading.css";
import clsx from "clsx";

export type HeadingProps = {
  as?: "h1" | "h2";
  className?: string;
} & React.PropsWithChildren &
  ComponentPropsWithRef<"div"> &
  styles.HeadingVariants;

export const Heading = ({
  size = "Large",
  as = "h1",
  children,
  className,
}: HeadingProps) => {
  const Component = as;

  return (
    <Component className={clsx(className, styles.heading({ size: size }))}>
      {children}
    </Component>
  );
};
